import styled from 'styled-components'
import { Popover } from '@velasca/ui/popover'

export const DutiesDisclaimerPopover = styled(Popover)`
  z-index: 1050;
`
